module.exports = __webpack_public_path__ + "static/media/Crypto-Investor-Screenshot.1346118b.jpg";